import { requestPageData } from '../../utilities/boundedPageData'
import axios from 'axios'
import React, { useEffect, useState, Suspense } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { productsSetFilters, getProductsFilters, productsResetFilters, getAllFilteredProducts } from '../../store/slices/entities/products';
import { wrapper } from '../../store/configStore';
import { SERVER_IP } from '../../store/middleware/api';
import { loadEntityForce } from '../../store/slices/entities/crmActions';
import { NextSeo, ProductJsonLd } from 'next-seo';
import { helper } from '../../utilities/helper';
import PicCont from '../../components/PicCont';
import Clickable from '../../components/Clickable';
import LinkWrap from '../../components/LinkWrap';
import Button from '../../components/Button';
import { AiOutlinePhone } from "@react-icons/all-files/ai/AiOutlinePhone";
import { FaWarehouse } from "@react-icons/all-files/fa/FaWarehouse";
import  { getUserUTM, cartAddItem, getUser, getUserGeo, cartAddedItem, purchaseAddItem, cartCleaned } from '../../store/slices/user';
import { getWorkingOrder, workingOrderItemsReceived, workingOrderReceived, workingOrderReset, workingOrderSetDetails } from '../../store/slices/entities/orders';
import * as gtag from '../../lib/gtag'
import { CLOSE_POPUP, showAlert, SHOW_POPUP } from '../../store/slices/ui';
import { TooltipIcon, SpinnerScreen, Spinner } from '../../components/Components';
import CatBar from '../../components/CatBar';
import { apiCallBegan } from '../../store/api';
import { AiOutlineShoppingCart } from '@react-icons/all-files/ai/AiOutlineShoppingCart';
import { FaWrench } from '@react-icons/all-files/fa/FaWrench';
import { AiOutlineQuestion } from '@react-icons/all-files/ai/AiOutlineQuestion';
import NoticeRow from '../../components/NoticeRow';
import { FiTruck } from '@react-icons/all-files/fi/FiTruck';
import CustomAlbum from '../../components/CustomAlbum';
import { FaStar } from "@react-icons/all-files/fa/FaStar";
import dynamic from 'next/dynamic'
import StarRating from '../../components/StarRating';
import { getWorkingPackage } from '../../store/slices/entities/packages';
import landings from '../../utilities/categoryLandings'
import { TiCancel } from '@react-icons/all-files/ti/TiCancel';
const AddUnits = dynamic(() => import('../../components/AddUnits'), { suspense: true })
const GiveReview = dynamic(() => import('../../components/GiveReview'), { suspense: true })
const AskQuestion = dynamic(() => import('../../components/AskQuestion'), { suspense: true })
import PageHeader from '../../components/PageHeader';
import IncludedProducts from '../../components/IncludedProducts';
import { FaExclamationTriangle } from '@react-icons/all-files/fa/FaExclamationTriangle';
import { useRouter } from 'next/router';
import { useOrderFlow } from '../../components/unified-order/OrderFlowProvider';
import { resolveOrderProduct } from '../../utilities/orderProductHydration';
import RentalStartPopup from '../../components/design-system/commerce/RentalStartPopup';
import ProductDetailV2 from '../../components/design-system/commerce/ProductDetailV2';
import { panelSet } from '../../store/slices/chatV2';
import { requiresMiamiFulfillment, resolveShoppingMarket } from '../../utilities/fulfillmentMarket';
import { withDateDependentRentalAvailability } from '../../utilities/productStructuredData';
import { applyPublicProductCopy } from '../../utilities/publicProductCopy';


export const getStaticProps = wrapper.getStaticProps(
  async ({ store, preview, params }) => {
    const [res, canonicals] = await Promise.all([
      requestPageData({
        url: `${SERVER_IP}/inventory/product/name/${params.name}?msr=true&page_view=v2`,
        label: 'product details',
        required: true,
        validateData: Array.isArray
      }),
      requestPageData({
        url: `${SERVER_IP}/subcategory/canonicals`,
        label: 'catalog canonical links',
        required: true,
        validateData: Array.isArray
      })
    ])
    const product = applyPublicProductCopy(res?.data?.[0])
    // The product is already delivered as a page prop. Keep the Redux cache
    // empty on first paint to avoid serializing the same record twice; the
    // existing static flag still makes rental actions load live inventory.
    store.dispatch({ type: productsSetFilters.type, payload: { static: true } })
    const portfolioProofResponse = product?._id
      ? await requestPageData({
        url: `${SERVER_IP}/newsletterevent/product/${product._id}`,
        label: 'product portfolio proof',
        fallback: null
      })
      : { data: null, usedFallback: false }

    return {
      props: {
        name: params.name,
        product,
        canonicals: canonicals?.data,
        portfolioProof: portfolioProofResponse?.data || null,
      },
      revalidate: portfolioProofResponse.usedFallback ? 60 : 3600,
    }
  }
);

export async function getStaticPaths() {
  const res = await axios.request(`${SERVER_IP}/inventory/product?msr_static=true`)
  let products = res.data

  const paths = products.map(product => ({ params: { name: helper.makeUrl(product.name) } }))

  return {
    paths,
    fallback: false
  }
}

const productSeoDescription = product => {
  const fulfillment = product?.allow_pickup === true
    ? 'warehouse pickup or professional delivery and setup'
    : 'professional delivery and setup'
  const lead = `${product?.name} rental in Miami or Orlando with ${fulfillment}.`
  const detail = String(product?.description || '').replace(/\s+/g, ' ').trim()
  const combined = `${lead} ${detail}`.trim()
  if (combined.length <= 158) return combined
  return `${combined.slice(0, 157).replace(/\s+\S*$/, '')}…`
}

const ProductPage = ({ name, product, canonicals, portfolioProof }) => {
  let utm = useSelector(getUserUTM)
  let router = useRouter()
  let {pathname, push, query} = router
  let [pict, setPict] = useState(0)
  let [pq, setPq] = useState(1)
  let [allPics, setAllPics] = useState(false)
  let dispatch = useDispatch()
  let _products = useSelector(getAllFilteredProducts)
  let filters = useSelector(getProductsFilters)
  let { cart, user } = useSelector(getUser)
  let order = useSelector(getWorkingOrder)
  let workingPackage = useSelector(getWorkingPackage)
  let geo = useSelector(getUserGeo)
  let { launchIntent, unifiedEnabled } = useOrderFlow()
  let unifiedEligible = unifiedEnabled && !workingPackage && !order?._id && !cart.items?.length
  let hasActiveRental = Boolean(order?._id && order?.request_type === 'rental' && !cart.production)
  let orlando = resolveShoppingMarket({geo, order, pathname}) === 'Orlando'
  let legacyProductView = query?.product_view === 'legacy'
  useEffect(()=> {
    setPict(0)
    setAllPics(false)
  }, [product])

  useEffect(() => {
    if (!product?._id) return
    gtag.event({
      action: 'view_item',
      label: 'single_product_page',
      category: 'products',
      value: product?.price?.rental,
      currency: 'USD',
      sourceSurface: legacyProductView ? 'single_product_page_legacy' : 'single_product_page_v2',
      productId: product._id,
      productName: product.name,
      items: [{
        item_id: product._id,
        item_name: product.name,
        item_category: product.categories?.[0]?.split('/')?.[0],
        item_category2: product.categories?.[0]?.split('/')?.[1],
        price: product?.price?.rental,
        quantity: 1
      }]
    })
  }, [legacyProductView, product])



  let MiniProd = ({ prod, showPrice, units }) => <LinkWrap href={`/products/${helper.makeUrl(prod.name)}`} className='miniProd'>
    <PicCont className='miniPic' picture={prod?.picture} alt={prod?.name} />
    <div className='infCol'>
      <span className='name'>{helper.shortText(prod?.name, 8)}</span>
      {showPrice && <span className='price'>{helper.formatPrice(prod.only_purchase ? prod?.price?.purchase :prod?.price?.rental)}</span>}
      {units > 0 && <strong >{units} Units</strong>}
    </div>
  </LinkWrap>


  // let addToPurchase = async(product) => {

  //   if(!order?._id) {
  //    let {_id} = await dispatch(apiCallBegan({url: `/order/purchase`, method: 'POST', data: {
  //       rental: {
  //         items: [{product: {_id:product._id, included: []}, units: pq}] ,

  //     },
  //     initial_inquiry: helper.getInitialRequest(pathname),
  //     start: new Date(),
  //     request_type: 'purchase',name: `Purchase Request - ${new Date().toDateString()}`,
  //     status: 'build',
  //     client: user?.client,
  //     google_ads: !!utm,
  //     orlando,
  //     site: 'msr',
  //     source: 'web'
  //     }, onSuccess: workingOrderSetDetails.type, showSpinner: true,}))
  //     dispatch(cartAddedItem({product, units: pq}))
  //     if(_id) push(`/planner?id=${_id}`)
  //   }else {
  //           dispatch(apiCallBegan({url:`/order/rental/items/${order._id}`, method: 'PUT', data: {product: {_id:product._id, included: []}, units: pq}, onSuccess: order?.status === 'checkout' ? workingOrderReceived.type : workingOrderItemsReceived.type,  showSpinner: true}))
  //   }
  // }

  let loadOrderProduct = async (requestedProduct, showSpinner = true) => {
    let loadedProducts
    if (filters.static) {
      loadedProducts = await dispatch(loadEntityForce('products', null, null, showSpinner))
      dispatch(productsResetFilters())
    }
    let orderProducts = Array.isArray(loadedProducts) ? loadedProducts : _products
    let currentProduct = resolveOrderProduct({
      requestedProduct,
      loadedProducts,
      cachedProducts: _products
    })
    return { currentProduct, orderProducts }
  }

  let addToCartItems = async (product, delivery) => {
    let units = 1
    if (unifiedEligible && !product.only_purchase && !product.price?.map) {
      return launchIntent({
        kind: 'product',
        entityId: product._id,
        entityName: product.name,
        sourceSurface: 'single_product_page',
        fulfillment: delivery ? 'delivery_setup' : 'pickup'
      })
    }
    if(order?.request_type === 'purchase' && !product.price.map) {
      if(!window.confirm(`This product is only available for rent, do you want to create a new rental order?`)) return
      else return   await dispatch(apiCallBegan({ url: `/order/${order?._id}`, method: 'DELETE', onSuccess: workingOrderReset.type, onSuccessFunc: () => cartCleaned() }))
  }
    let { currentProduct: _pr, orderProducts } = await loadOrderProduct(product)
    if (!_pr) return dispatch(showAlert({ type: 'error', alert: `${product.name} could not be loaded. Please refresh and try again.` }))
    if (delivery) {
      if (orlando && requiresMiamiFulfillment(_pr, units)) {
        if (!window.confirm(`${_pr?.name} is available from Miami, not Orlando, for these dates. Continuing will create or convert the order to Miami fulfillment and may add a travel fee. Continue?`)) return
      }
      if (!cart.production && order?._id) await dispatch(apiCallBegan({ url: `/order/${order._id}`, method: 'DELETE', onSuccess: workingOrderReset.type }))
      return dispatch(cartAddItem({ product: _pr, units, category: _pr.categories[0].split('/')[1], delivery: true }))
    } else {
      if (order?._id && units > 0 && (_pr.available - units < 0 || (_pr.bundle && _pr.included?.some(ip => orderProducts.find(produ => String(produ._id) == String(ip.product._id))?.available - (units * ip.units) < 0)))) return dispatch(showAlert({ type: 'error', alert: `${product.name} has no more units available for the selected date` }))
      if (!cart.production && (_pr.requires_tech || !_pr.allow_pickup)) {
        if (!window.confirm(`${product.name} requires installation by a Dry N Wet technician, adding it to your order will convert it to a production. Do you wish to continue?`)) return
        else if (order?._id) {
          await dispatch(apiCallBegan({ url: `/order/${order._id}`, method: 'DELETE', onSuccess: workingOrderReset.type }))
        }
      }
      await dispatch(cartAddItem({ product: _pr, units, category: _pr.categories[0].split('/')[1] }))
    }
  }

  let openRentalStart = (requestedProduct, sourceSurface = 'single_product_page') => {
    if (hasActiveRental) return addToCartItems(requestedProduct)

    gtag.event({
      action: 'rent_online_cta_click',
      label: 'sales',
      value: 5,
      category: 'orders',
      sourceSurface,
      productId: requestedProduct?._id,
      productName: requestedProduct?.name
    })
    dispatch(SHOW_POPUP({
      key: `rentalStart-${requestedProduct._id}`,
      size: 'xl',
      className: 'rentalStartShell',
      trapFocus: true,
      ariaLabelledBy: 'rental-start-title',
      body: <RentalStartPopup
        product={requestedProduct}
        orlando={orlando}
        selectionOnly={unifiedEligible}
        resolveProduct={unifiedEligible ? undefined : async () => {
          let { currentProduct } = await loadOrderProduct(requestedProduct, false)
          if (!currentProduct) {
            dispatch(showAlert({ type: 'error', alert: `${requestedProduct.name} could not be loaded. Please refresh and try again.` }))
            return null
          }
          gtag.event({
            action: 'add_to_cart',
            label: 'sales',
            value: currentProduct.price?.rental,
            category: 'orders',
            currency: 'USD',
            sourceSurface,
            productId: currentProduct._id,
            productName: currentProduct.name,
            items: [{
              item_id: currentProduct._id,
              item_name: currentProduct.name,
              index: 0,
              item_category: currentProduct.categories?.[0]?.split('/')?.[0],
              item_category2: currentProduct.categories?.[0]?.split('/')?.[1],
              price: currentProduct.price?.rental,
              quantity: 1
            }]
          })
          return currentProduct
        }}
        onSelect={async (delivery, selectedProduct) => {
          gtag.event({
            action: delivery ? 'rent_online_delivery_selected' : 'rent_online_pickup_selected',
            label: 'sales',
            value: 5,
            category: 'orders',
            fulfillment: delivery ? 'delivery_setup' : 'pickup',
            sourceSurface,
            productId: selectedProduct?._id,
            productName: selectedProduct?.name
          })
          if (unifiedEligible) {
            dispatch(CLOSE_POPUP({ all: true }))
            await addToCartItems(selectedProduct, delivery)
            return false
          }
          if (delivery && orlando && requiresMiamiFulfillment(selectedProduct)) {
            if (!window.confirm(`${selectedProduct.name} is available from Miami, not Orlando. Continuing will create a Miami-fulfilled order and may add a travel fee. Continue?`)) return false
          }
          return true
        }}
      />
    }))
  }

  if (!product?.name) return <SpinnerScreen />

  let cat = product?.categories?.[0].split('/')[0]

  let subCat = product?.categories?.[0].split('/')[1]
  subCat = cat === 'Bundle' && product?.categories?.[1] ? product?.categories?.[1].split('/')[1] : subCat
  cat = cat === 'Bundle' && product?.categories?.[1] ? product?.categories?.[1].split('/')[0] : cat

  let canon = canonicals.find(c => c.parent === cat && c.name === subCat)

  let estimated_del = product.price.rental * ((product?.difficulty / 10)) *1.35
      let req_two = product.requires_two
    let show_min = false

    if(estimated_del < (req_two ? 240 : 120)) show_min =req_two ? 240 : 120
  let showRental = ((order?.request_type !== 'purchase' && (!product.only_purchase || workingPackage || order?.request_type === 'rental')) || (order?.request_type === 'purchase' && !product.only_purchase && !product?.price?.map))
  let showPurchase = product?.price?.map > 0 && !workingPackage && order?.request_type !== 'rental'
  let seoDescription = productSeoDescription(product)
  let structuredDataExpiry = `${new Date().getUTCFullYear() + 1}-12-31`
  let categoryHref = String(landings[cat] || `/${helper.makeUrl(cat)}`).replace('https://miamisoundrental.com', '')
  let subCategoryHref = String(canon?.url || `/${helper.makeUrl(cat)}/${helper.makeUrl(subCat)}`).replace('https://miamisoundrental.com', '')

  let setProductView = view => {
    const nextQuery = { ...router.query }
    if (view === 'legacy') nextQuery.product_view = 'legacy'
    else delete nextQuery.product_view
    router.replace({ pathname: router.pathname, query: nextQuery }, undefined, { shallow: true, scroll: false })
  }

  return <div className='productPageCont' data-product-id={product._id}>
    <NextSeo
      noindex={product?.price?.rental < 30}
      title={`${helper.shortText(product.name, 8)} Rental`}
      description={seoDescription}
      canonical={`https://miamisoundrental.com/products/${name}`}
      twitter={{
        handle: '@miamisoundrent1',
        site: '@miamisoundrent1',
        cardType: 'summary_large_image',
      }}
      openGraph={{
        type: 'website',
        url: `https://miamisoundrental.com/products/${name}`,
        title: `${helper.shortText(product.name, 8)} Rental`,
        description: seoDescription,
        images: [
          {
            url: `https://dnw-server.s3.us-east-2.amazonaws.com/${product.picture}`,
            width: 600,
            height: 600,
            alt: product.name,
          },
        ],
        site_name: 'Miami Sound Rental',
      }}
    />
    <ProductJsonLd
      productName={product.name}
      images={[
        `https://dnw-server.s3.us-east-2.amazonaws.com/${product.picture}`,
        ...(product.pictures || []).map(p => `https://dnw-server.s3.us-east-2.amazonaws.com/${p}`)
      ]}
      description={product.description}
      brand={product.brand}
      reviews={(product.reviews || []).map(pr => ({
        author: pr?.user?.first_name,
        datePublished: pr.datePublished,
        reviewBody: pr.reviewBody,
        name: pr.name,
        reviewRating: {
          bestRating: '5',
          ratingValue: pr.rating,
          worstRating: '1',
        }
      }))}
      aggregateRating={product.reviews?.length ? {
        ratingValue: product.reviews.reduce((a, b) => a + b.rating, 0) / product.reviews.length,
        reviewCount: product.reviews.length,
      } : undefined}
      offers={[
        withDateDependentRentalAvailability({
          price: product.only_purchase ? (product?.price?.map || product?.price?.purchase).toFixed(2)  : product.price?.map ? product.price?.map?.toFixed(2) : product.price?.rental?.toFixed(2),
          priceCurrency: 'USD',
          priceValidUntil: structuredDataExpiry,
          url: `https://miamisoundrental.com/products/${name}`,
          seller: {
            name: 'Miami Sound Rental',
          },
        })
      ]}
    />
    {legacyProductView ? <>
       <PageHeader breadcrumbs={[[cat, landings[cat] || helper.makeUrl(cat)], [subCat,canon?.url || `/${helper.makeUrl(cat)}/${helper.makeUrl(subCat)}` ]]} >
       <h1 > {helper.shortText(product.name, 10)} </h1>
        </PageHeader>
    <div className='productFullPage' >

      <div className="pictureRow">
        <div className="picCol">
          <PicCont className={pict ? 'h' : ''} width={pict ? 800 :600} height={600} priority picture={pict ? product.pictures[pict-1] :product.picture} />


        {product?.pictures?.length > 0 &&<><div className="row">
           {[product.picture,...product?.pictures].slice(0, allPics ?[product.picture,...product?.pictures].length: 6).map((p,i) => <PicCont loading='lazy' width={i === 0 ? 180 :240} height={180} className={`miniPic ${i >0 ? 'h' : ''}`}  key={i} picture={p} alt={name + ` - #${i}`} onClick={() => setPict(i)} />) }
        </div>
        {[product.picture,...product?.pictures]?.length >6 && !allPics && <Clickable onClick={() => setAllPics(true)}>View {[product.picture,...product?.pictures]?.length-6} more pictures.</Clickable>}
        </>}

        </div>
        <section className="infoCol">
        {product?.reviews?.length >0 &&  <a href='#reviews' className='reviewsRow'>
          <StarRating rating={product.reviews.reduce((a, b) => a + b.rating, 0) / product.reviews.length} showNumber={product.reviews.length} />
            </a>}

        <p className="description">{product.description}</p>
        {!product.orlando && orlando && <strong className="delivery warning"><TooltipIcon icon={<FaExclamationTriangle/>}>This item is stocked in Miami. Adding it to an Orlando order changes fulfillment to Miami and may add one travel fee for the order.</TooltipIcon> Miami warehouse item · travel may apply</strong>}
        {product?.price?.map >0 && !workingPackage && (order?.request_type !== 'rental') &&       <div className='priceComp mapPriceComp'>
          <strong className="price"><span className='mapNot'>Purchase {!product.only_purchase && ' New'} for:</span>{helper.formatPrice(product.price.map)}</strong>


              <div className='buttons'>
              <div className={`inputIcon`}>
                            <label htmlFor='pq' >Quantity</label>
                            <select id='pq' aria-label='pq' value={pq} onChange={(e) => setPq(e.target.value)} >
                              {[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20].map(n => <option value={n} key={n}>{n}</option>)}

                            </select>
                        </div>
            {/* <Button onClick={() => addToCartItems(product, true, true)} className={`btn-4 highLight `}><FiTruck />Schedule Delivery</Button> */}
         <Button disabled={!product.allow_pickup || (!product.orlando && orlando)} onClick={() =>  dispatch(purchaseAddItem({product, units: pq, push, orlando, user, pathname }))}   className='btn-4 highLight '><AiOutlineShoppingCart />Purchase Product</Button>
          </div>

        </div>}
      {((order.request_type !== 'purchase' && (!product.only_purchase || workingPackage || order?.request_type === 'rental')) || (order.request_type === 'purchase' && !product.only_purchase && !product?.price?.map) ) &&  <div className='priceComp' id='rent-online'>
          <strong className="price">{product?.price?.map >0 && <span className='mapNot'>{product.only_purchase ? 'Purchase' :'Rent'} for:</span>} {helper.formatPrice(product.only_purchase ? (product.price?.map || product?.price?.purchase) :product.price.rental)}<a href='#delivery' className='disclaimer'>* Estimated Delivery & Intallation {helper.formatPrice(estimated_del)}{show_min ? <div className='minDel'>({helper.formatPrice(show_min)} min delivery)</div> : null}</a></strong>

         { workingPackage ?
         <div className='buttons buttonUnits'>
             <Suspense fallback={<Spinner size='tiny' />}> <AddUnits  subCat pack selectedUnits={workingPackage.components.find(item => item.product.name === product?.name)?.units || 0} product={product} /></Suspense>
             </div> :
              <div className='buttons'>
            <Button onClick={() => addToCartItems(product, true)} className={`btn-4 highLight `}><FiTruck />{unifiedEligible ? 'Add with delivery & setup' : 'Schedule Delivery'}</Button>
            {(cart?.items?.some(i => i?.product?._id === product._id) ?  <Suspense fallback={<Spinner size='tiny' />}> <AddUnits  selectedUnits={cart?.items?.find(item => item.product.name === product?.name)?.units || 0} product={product} /></Suspense>
         : product?.allow_pickup === true && <Button disabled={!product.orlando && orlando} onClick={() => addToCartItems(product)}   className='btn-4 highLight '>{!product.orlando && orlando ? <TiCancel/>  :<AiOutlineShoppingCart />} {!product.orlando && orlando ? 'Pickup Not Available' : product?.only_purchase? "Purchase Product" : unifiedEligible ? 'Add for warehouse pickup' : 'Add to Rental'}</Button>)}
          </div>}

        </div>}
        {product.included?.length > 0 && order?.request_type !== 'purchase' && <IncludedProducts  product={product} />}



       {!workingPackage &&   <NoticeRow orlando={orlando} product={product} addToCartItems={addToCartItems} unifiedEligible={unifiedEligible} />}

          <div className="help">
            <PicCont picture={'myImage-1625767319150.jpg'} />
            <div className="col">
              <strong>Need some help selecting your equipment?</strong>
              <span>Give us a call and we will be happy to assist you.</span>
              <a className="assCall" href={orlando ? "tel:+14078070052" :"tel:+13059744411"}  onClick={() => gtag.event({ action: 'booking_assistance_call', label: 'leads', value: 15, category: 'orders' })}>
                <AiOutlinePhone />{orlando ? '407 807 0052' :'305 974 4411'}
              </a>
            </div>
          </div>
        </section>
      </div>

      {product.recommended_products?.length > 0 && <div className='prods'>
            <div className="head upper">Frequently Rented Together</div>
            <div className="prodsRow">
              {product.recommended_products.map((p, i) => <MiniProd prod={p} key={i} showPrice={true} />)}
            </div>
          </div>}
          {product.alternatives?.length > 0 && <div className='prods'>
            <div className="head upper">Similar Products</div>
            <div className="prodsRow">
              {product.alternatives.map((p, i) => <MiniProd prod={p} key={i} showPrice={true} />)}
            </div>
          </div>}


          <section className="customerRev">
            <div className='upper'>Customer Reviews</div>

            <div className='row'>
            {product.reviews?.length > 0 ? <div className='reviewColumn' id='reviews' >

         {[...product.reviews].reverse().map((rev, i) => <div key={i} className='singleRev'>
           <div className="revHead">
           <strong>{rev?.user?.first_name}</strong>
             <span>{new Date(rev.datePublished).toDateString()}</span>

           </div>
          <div className='revBody'>
           <div className="revTop">
           <strong>{rev.name}</strong>
           <StarRating rating={rev.rating} />

           </div>
           <p>{rev.reviewBody}</p>
           </div>
         </div>)}
       </div>
         :
         <p className='noReviews'>This product has no reviews yet, be the first one to leave a review!</p>}
            <div className='rightCol '>
              {product.reviews?.length > 0 &&   <StarRating rating={product.reviews.reduce((a, b) => a + b.rating, 0) / product.reviews.length} showNumber={product.reviews.length} />}
          <Button className='btn-4 highLight ' onClick={() => dispatch(SHOW_POPUP({ size: 'big', key: 'review', body: <Suspense fallback={<Spinner size='tiny' />}><GiveReview product={product} /></Suspense> }))} >Leave Review</Button>
          </div>
            </div>

            </section>
          <section className="customerRev">
            <div className='upper'>Questions & Answers</div>

            <div className='row'>
            {product.qna?.filter(q => q.includes('/answer/'))?.length > 0 ? <div className='reviewColumn' >
       {product.qna?.filter(q => q.includes('/answer/')).map((q, i) => <div key={i} className='qna'>
        <span className='question'>{q.split('/answer/')[0]}</span>
        <span className='answer'>{q.split('/answer/')[1]}</span>
       </div>)}
          </div>
            :
            <p className='noReviews'>Be the first one to ask a question about the product.</p>}
            <div className='rightCol '>

              <Button className='btn-4 highLight ' onClick={() => dispatch(SHOW_POPUP({ size: 'big', key: 'review', body: <Suspense fallback={<Spinner size='tiny' />}><AskQuestion product={product} /></Suspense> }))} >Ask A Question</Button>
          </div>
            </div>

            </section>
    </div>
    <div className='legacyProductVariantSwitch'>
      <Button className='btn-4' onClick={() => setProductView('v2')}>Use new product page</Button>
    </div>
    </> : <ProductDetailV2
      product={product}
      category={cat}
      subCategory={subCat}
      categoryHref={categoryHref}
      subCategoryHref={subCategoryHref}
      orlando={orlando}
      order={order}
      cart={cart}
      workingPackage={workingPackage}
      purchaseQuantity={pq}
      setPurchaseQuantity={setPq}
      showRental={showRental}
      showPurchase={showPurchase}
      deliveryEstimate={estimated_del}
      deliveryMinimum={show_min}
      portfolioProof={portfolioProof}
      onOpenRentalStart={(selectedProduct) => openRentalStart(selectedProduct, 'single_product_page_v2')}
      onPurchase={() => dispatch(purchaseAddItem({ product, units: pq, push, orlando, user, pathname }))}
      onChooseRelated={(selectedProduct) => hasActiveRental
        ? addToCartItems(selectedProduct)
        : openRentalStart(selectedProduct, 'single_product_page_related')}
      onViewRelated={(selectedProduct) => gtag.event({
        action: 'select_item',
        label: 'single_product_page_related',
        category: 'products',
        sourceSurface: 'single_product_page_related',
        productId: selectedProduct?._id,
        productName: selectedProduct?.name
      })}
      onAskQuestion={() => dispatch(SHOW_POPUP({ size: 'big', key: 'review', body: <Suspense fallback={<Spinner size='tiny' />}><AskQuestion product={product} /></Suspense> }))}
      onLeaveReview={() => dispatch(SHOW_POPUP({ size: 'big', key: 'review', body: <Suspense fallback={<Spinner size='tiny' />}><GiveReview product={product} /></Suspense> }))}
      onCall={() => gtag.event({ action: 'booking_assistance_call', label: 'leads', value: 15, category: 'orders', sourceSurface: 'single_product_page_v2' })}
      onChat={() => {
        gtag.event({ action: 'booking_assistance_chat', label: 'leads', value: 5, category: 'orders', sourceSurface: 'single_product_page_v2' })
        dispatch(panelSet(true))
      }}
      onViewPortfolioProof={(event) => gtag.event({
        action: 'portfolio_case_study_open',
        label: event?.title,
        category: 'portfolio',
        sourceSurface: 'single_product_page_portfolio_proof',
        productId: product?._id,
        productName: product?.name,
      })}
      onUseLegacy={() => setProductView('legacy')}
    />}
  </div>
}

export default ProductPage
